// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type BackendListLastActivityQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
}>;

export type BackendListLastActivityQuery = {
  __typename?: "GraphqlQuery";
  getServerDetails: {
    __typename?: "Server";
    id: string;
    lastActivitySnapshotAt?: number | null;
    currentTime?: number | null;
  };
};

export const BackendListLastActivityDocument = gql`
  query BackendListLastActivity($serverId: ID!) {
    getServerDetails(serverId: $serverId) {
      id
      lastActivitySnapshotAt
      currentTime
    }
  }
`;

/**
 * __useBackendListLastActivityQuery__
 *
 * To run a query within a React component, call `useBackendListLastActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackendListLastActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackendListLastActivityQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *   },
 * });
 */
export function useBackendListLastActivityQuery(
  baseOptions: Apollo.QueryHookOptions<
    BackendListLastActivityQuery,
    BackendListLastActivityQueryVariables
  > &
    (
      | { variables: BackendListLastActivityQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BackendListLastActivityQuery,
    BackendListLastActivityQueryVariables
  >(BackendListLastActivityDocument, options);
}
export function useBackendListLastActivityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackendListLastActivityQuery,
    BackendListLastActivityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BackendListLastActivityQuery,
    BackendListLastActivityQueryVariables
  >(BackendListLastActivityDocument, options);
}
// @ts-ignore
export function useBackendListLastActivitySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    BackendListLastActivityQuery,
    BackendListLastActivityQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  BackendListLastActivityQuery,
  BackendListLastActivityQueryVariables
>;
export function useBackendListLastActivitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackendListLastActivityQuery,
        BackendListLastActivityQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  BackendListLastActivityQuery | undefined,
  BackendListLastActivityQueryVariables
>;
export function useBackendListLastActivitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackendListLastActivityQuery,
        BackendListLastActivityQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    BackendListLastActivityQuery,
    BackendListLastActivityQueryVariables
  >(BackendListLastActivityDocument, options);
}
export type BackendListLastActivityQueryHookResult = ReturnType<
  typeof useBackendListLastActivityQuery
>;
export type BackendListLastActivityLazyQueryHookResult = ReturnType<
  typeof useBackendListLastActivityLazyQuery
>;
export type BackendListLastActivitySuspenseQueryHookResult = ReturnType<
  typeof useBackendListLastActivitySuspenseQuery
>;
export type BackendListLastActivityQueryResult = Apollo.QueryResult<
  BackendListLastActivityQuery,
  BackendListLastActivityQueryVariables
>;
